// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__LY0Wg","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__1Snws"};